import { CardTemplate } from 'types/story';
import { CardEvent } from 'admin/components/pages/Story/Flow/Connector/ConnectorSvg/utils';
import { FLOAT_ABOVE } from 'client/components/common/BuildingBlocks/FloatAbove';
import { FLOAT_BELOW } from 'client/components/common/BuildingBlocks/FloatBelow';
import { CONTENT } from 'client/components/common/BuildingBlocks/Content';
import { CARD } from 'client/components/common/BuildingBlocks/Card';
import { generateCardId } from 'common/utils/generate-id';

export function defaultTemplate(): CardTemplate {
	const cardId = generateCardId();
	return {
		id: '',
		name: 'Blank page',
		subtitle: 'Blank template.',
		description: 'Blank template to build your card from scratch.',
		organizationId: null,
		editor: {
			card: {
				_id: cardId,
				elements: [FLOAT_ABOVE().model, CONTENT().model, FLOAT_BELOW().model, CARD().model],
				settings: {},
				events: [CardEvent()],
			},
		},
		metadata: {
			storySettings: {
				cards: {
					[cardId]: {},
				},
			},
			storyId: '',
			cardId: '',
			clientStoryId: '',
			version: process.env.VERSION as string,
			defaultPlatform: 'default',
		},
		type: 'card',
		language: '',
		categories: [],
	};
}
